import { Type } from 'class-transformer';
import { IsEmail, IsOptional, IsString, IsUUID, ValidateIf, IsArray, IsBoolean, ValidateNested } from 'class-validator';
import { SopRelationshipDto } from '../complaints-process-config/sop-relationship.dto';
import { IsCommaSeparatedEmails } from '../../../../utils';

export class CreatePvProcessConfigRequestDto {
    /**
     * AE Assessment Organization ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsOptional()
    @ValidateIf((o) => o.aeAssessmentOrganizationId !== '' && o.aeAssessmentOrganizationId != null)
    @IsUUID()
    aeAssessmentOrganizationId?: string;

    /**
     * Email for AE reporting
     * @example 'ae.reports@example.com'
     */
    @IsOptional()
    @ValidateIf((o) => o.aeReportingEmail !== '' && o.aeReportingEmail != null)
    @IsCommaSeparatedEmails()
    aeReportingEmail?: string;

    /**
     * PMS Organization ID
     * @example '123e4567-e89b-12d3-a456-426614174001'
     */
    @IsOptional()
    @ValidateIf((o) => o.pmsOrganizationId !== '' && o.pmsOrganizationId != null)
    @IsUUID()
    pmsOrganizationId?: string;

    /**
     * Email for PMS activities
     * @example 'pms@example.com'
     */
    @IsOptional()
    @ValidateIf((o) => o.pmsEmail !== '' && o.pmsEmail != null)
    @IsCommaSeparatedEmails()
    pmsEmail?: string;

    /**
     * Literature Search Organization ID
     * @example '123e4567-e89b-12d3-a456-426614174002'
     */
    @IsOptional()
    @ValidateIf((o) => o.literatureSearchOrganizationId !== '' && o.literatureSearchOrganizationId != null)
    @IsUUID()
    literatureSearchOrganizationId?: string;

    @IsOptional()
    @IsBoolean()
    qncConductingGvpSelfInspection?: boolean;

    @IsOptional()
    @IsString()
    gvpSelfInspectionFrequency?: string;

    /**
     * Notes on PV process
     * @example 'Q&C not involved for AE assessment'
     */
    @IsOptional()
    @IsString()
    notes?: string;

    @IsOptional()
    @IsArray()
    @ValidateNested({ each: true })
    @Type(() => SopRelationshipDto)
    sops?: SopRelationshipDto[];
}
